import React from "react";
import { Card, Grid, Skeleton } from "@mantine/core";

export default function ExpertCardSkeleton() {
  return (
    <Card
      padding={"lg"}
      className="px-[23px] py-[20px] my-2"
      style={{ borderRadius: "12px" }}
      withBorder
    >
      <Grid align="center">
        <Grid.Col span={4}>
          <div className="flex items-center">
            <Skeleton height={60} circle />
            <div className="ms-4">
              <Skeleton height={24} mb={8} width={130} radius="xl" />
              <Skeleton height={17} mt={8} width={150} radius="xl" />
            </div>
          </div>
        </Grid.Col>
        <Grid.Col span={3} className="h-full justify-between">
          <div className="flex flex-wrap">
            <Skeleton height={24} width={80} radius="sm" mt={4} mx={4} />
          </div>
          <div className="flex mt-2 items-center text-primary">
            <Skeleton height={18} mt={0} mx={4} width={100} radius="xl" />
          </div>
        </Grid.Col>
        <Grid.Col span={4} className="flex flex-col h-full">
          <div className="flex flex-wrap items-center text-primary">
            <Skeleton height={18} mt={0} mx={4} width={100} radius="xl" />
          </div>
          <div className="flex mt-2 flex-wrap items-center text-primary">
            <Skeleton height={18} mt={0} mx={4} width={100} radius="xl" />
          </div>
        </Grid.Col>
        <Grid.Col span={1} className="flex items-center lg:justify-end ">
          <Skeleton height={36} width={140} radius="xl" />
        </Grid.Col>
      </Grid>
    </Card>
  );
}
